import { gql } from '@apollo/client';
import { JOB_USER_FRAGMENT } from './record';

export const PROMPT_VERSION_FIELDS = gql`
  ${JOB_USER_FRAGMENT}
  fragment PromptVersionFields on PromptVersion {
    version
    text
    metadata
    notes
    createdAt
    createdBy
    createdByUser {
      ...JobUser
    }
  }
`;

export const PROMPT_FIELDS = gql`
  ${PROMPT_VERSION_FIELDS}
  fragment PromptFields on Prompt {
    id
    name
    code
    text
    format
    typeId
    metadata
    notes
    createdAt
    updatedAt
    createdBy
    createdByUser {
      ...JobUser
    }
    versions {
      ...PromptVersionFields
    }
  }
`;
